import { EDIT_LISTING_LOCATION,
         CLOSE_LISTING_LOCATION,
         PENDING_SUBMIT_LISTING_LOCATION,
         COMPLETE_SUBMIT_LISTING_LOCATION,
         FAILED_SUBMIT_LISTING_LOCATION
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false,
    propertylocationediting: false
}


const mlListingLocation = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_LISTING_LOCATION: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertylocationediting: true
        }

        case CLOSE_LISTING_LOCATION: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertylocationediting: false
        }

        case PENDING_SUBMIT_LISTING_LOCATION: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_LOCATION: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_LOCATION: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingLocation